import { createHeroView, createNavigationView } from './index'

const Stats = () => import('../components/Stats/Stats.vue')
const OccupationStatModal = () => import('../components/Stats/OccupationStatModal')
const OfferStatModal = () => import('../components/Stats/OfferStatModal')
const Adverts = () => import('../components/Stats/Adverts/Adverts.vue')
const Employers = () => import('../components/Stats/Employers/Employers.vue')
const AdWatchModal = () => import('../components/Stats/AdWatches/AdWatchModal.vue')
const AdWatchStatModal = () => import('../components/Stats/AdWatches/AdWatchStatModal.vue')
const ProfileSidebar = () => import('../components/Profile/ProfileSidebar.vue')

export const routes = () => [
  {
    path: '/statisztika',
    components: {
      default: Stats,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    children: [
      {
        path: 'munkakor/:occupationName',
        component: OccupationStatModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Statistics - Occupation statistics',
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: 'hirdetesfigyelo/:occupationName',
        component: AdWatchStatModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Statistics - Ad watch statistics',
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: 'ajanlat/:occupationName',
        component: OfferStatModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Statistics - Offer statistics',
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Statistics',
      requiresAuth: true,
      requiresValidProfile: true,
      hasAuthModal: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/statisztika/hirdetesek',
    components: {
      default: Adverts,
      hero: createHeroView('about'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Statistics - Ads'
    }
  },
  {
    path: '/statisztika/munkakorok',
    components: {
      default: Employers,
      hero: createHeroView('about'),
      navigation: createNavigationView()
    },
    children: [
      {
        path: 'hirdetesfigyelo/:occupationName',
        component: AdWatchModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Statistics - Ad watch'
        }
      }
    ],
    meta: {
      pageTitle: 'Statistics - Occupations'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/stat.js